import { RATE_TYPE_OPTIONS } from "../../constants";
import { LiabilityRateTypes } from "../../types";

export const FORM_ID = "add-liability";

const VARIABLE_RATE_OPTION =
  RATE_TYPE_OPTIONS.find(
    (option) => option.label === LiabilityRateTypes.VARIABLE,
  ) ?? RATE_TYPE_OPTIONS[0];

export const DEFAULT_LIABILITY = {
  name: "",
  amount: "",
  institution: "",
  liabilityTypeId: null,
  startDate: new Date(),
  term: "",
  interestRate: "",
  rateType: VARIABLE_RATE_OPTION,
  resetFrequency: null,
  paymentFrequency: null,
  paymentDueDay: null,
  paymentAmount: "",
};
